import Vue from "vue";
import VueRouter from "vue-router";
import { routers } from "./routers";

import gl from '@/api/global';

import store from '@/store'
import cookies from 'vue-cookies'

Vue.use(VueRouter);

const RouterConfig = {
  // mode: 'history',
  routes: routers
};

const router = new VueRouter(RouterConfig);

function GetQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return decodeURI(r[2]);
  return null;
}

router.beforeEach((to, from, next) => {
  const nextRoute = ["404", "500"];
  let cookie_userId = cookies.get('sso_userId')
  let cookie_token = cookies.get("sso_token")
  // console.log(cookie_userId)
  // console.log(cookie_token)
  if (cookie_userId) {
    //缓存有user
    let lastName = from.name ? from.name.toString() : 'home'
    store.commit('setData', { key: 'lastRoute', val: { name: lastName, params: from.params } })
    next();
    // router.push({ name: "login" });
  } else {
    // 未登录
    window.location.href = gl.rzUrl + '/#/info/?href=' + window.location.href;

    // router.replace({ name: "login" });
  }
  // let userObj = JSON.parse(localStorage.getItem("userObj"))
  // let hasLogin = JSON.parse(localStorage.getItem("hasLogin"))


  // let token = to.query.token;
  // let userId = to.query.userid;
  // // console.log("userObj--", userObj)
  // // console.log("token--", token)
  // // console.log("userId--", userId)
  // // console.log(GetQueryString('token'))
  // // console.log(GetQueryString('userid'))

  // // console.log(nextRoute.indexOf(to.name),to.name)
  // // let noLogin = !userObj && token == undefined && userId == undefined  //没登录，url没有token userId\
  // let noLogin = !hasLogin
  // let hasToken = token !== undefined && userId !== undefined
  // // console.log("noLogin--", noLogin)
  // // console.log("token--", to.query.token)
  // // console.log("hasToken--", hasToken)
  // // console.log("hasLogin--", hasLogin)
  // if (hasToken) {
  //   console.log('hastoken')
  //   localStorage.setItem('token', token)
  //   localStorage.setItem('userId', userId)
  //   store.dispatch('getUserMess', userId).then(res => {

  //     if (res.status == null) router.replace({ name: "register" });
  //     else if (res.status == 0) router.replace({ name: "tipWarning", params: { status: res.status } });
  //     else if (res.status == 1) router.replace({ name: "tipWarning", params: { status: res.status, obj: res } });
  //     else if (res.status == 2) router.replace({ name: "tipWarning", params: { status: res.status, obj: res.params.surplus } });
  //     else if (res.status == 3) router.replace({ name: "tipWarning", params: { status: res.status, obj: res.params.surplus } });
  //     else if (res.status == 4) router.replace({ name: "home" });
  //     else if (res.status == 5) router.replace({ name: "tipWarning", params: { status: res.status, obj: res } });
  //     else if (res.status == 6) router.replace({ name: "tipWarning", params: { status: res.status, obj: res.params.reason } });
  //     else if (res.status == 7) router.replace({ name: "tipWarning", params: { status: res.status, obj: res } });
  //     else if (res.status == 8) router.replace({ name: "tipWarning", params: { status: res.status, obj: res } });
  //     else if (res.status == 9) router.replace({ name: "tipWarning", params: { status: res.status, obj: res } });
  //     else if (res.status == 10) router.replace({ name: "tipWarning", params: { status: res.status, obj: res } });
  //   })
  // } else {
  //   if (noLogin) {
  //     console.log('noLogin')
  //     // console.log(gl.rzUrl + '/#/info/?href=' + window.location.href)
  //     window.location.href = gl.rzUrl + '/#/info/?href=' + window.location.href;
  //   }
  //   else {
  //     // console.log(from)
  //     let lastName = from.name ? from.name.toString() : 'home'
  //     store.commit('setData', { key: 'lastRoute', val: { name: lastName, params: from.params } })
  //     next();
  //   }
  // }


})

export default router;
